import React, { FunctionComponent, useMemo } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  Button,
  LinkProps,
  HStack,
} from "@chakra-ui/react";
import { WarningTwoIcon } from "@chakra-ui/icons";

import { IAlarmInfo } from "common/all-sites-data";

import AlarmsIndicator from "components/alarms-indicator";


interface IProps extends LinkProps {
  siteId: string;
  label: string;
  slug: string;
  alarmsNavTab: string;
  alarms?: IAlarmInfo[] | boolean;
  selected?: boolean;
}


const SiteMenuItem: FunctionComponent<IProps> = ({
  siteId,
  label,
  slug,
  alarmsNavTab,
  alarms,
  selected = false,
  ...rest
}) => {
  const navigate = useNavigate();
  const basePath = `/site/${siteId}`;
  const to = `${basePath}${slug ? "/" + slug : ""}`;
  const hasAlarms = useMemo<boolean>(() => alarms ? (alarms === true || alarms.length > 0) : false, [alarms]);
  const alarmNavTabs = useMemo<string[]>(() => ["alarms", "notifications"], []);

  return (
    <HStack spacing={-2} key={label}>
    <Link to={to}>
      <Button
        rounded="full"
        colorScheme={hasAlarms ? "red" : alarms !== undefined || selected ? "enposol" : undefined}
        variant={selected ? "solid" : "ghost"}
      >
        {label}
        { alarmNavTabs.includes(slug) && hasAlarms && <WarningTwoIcon ml={2} /> }
      </Button>
    </Link>
    { !alarmNavTabs.includes(slug) && hasAlarms && <AlarmsIndicator
      onClick={() => {
        navigate(`${basePath}/${alarmsNavTab}`)
      }}
      size="sm"
    />}
    </HStack>
  );
};

export default SiteMenuItem;
